export default __webpack_public_path__ + "static/media/section1_2.2b12a855.png";